import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

// Use the 'keyframes' helper with backticks
const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
`;

// Use styled(motion.div) with backticks
const ArrowContainer = styled(motion.div)`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  cursor: pointer;
  animation: ${floatAnimation} 2s ease-in-out infinite;

  @media (max-width: 768px) {
    display: none;
  }
`;

// Use styled.img with backticks
const ArrowImage = styled.img`
  width: 40px;
  height: auto;
  
  @media (max-width: 768px) {
    width: 30px;
  }
`;

const FloatingArrow = ({ onClick }) => {
  return (
    <ArrowContainer
      onClick={onClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1, duration: 0.5 }}
    >
      <ArrowImage src="/arrow.png" alt="Scroll Down" />
    </ArrowContainer>
  );
};

export default FloatingArrow;